<template>
  <v-container class="mt-16">
    <div class="pl-10 pr-10">
      <v-card flat>
        <v-card-title class="d-flex">
          <h2>Journal Entries</h2>

          <v-spacer></v-spacer>

          <v-btn color="success" text @click="refresh" :loading="loading"
            ><v-icon class="mr-2">mdi-refresh</v-icon>Refresh</v-btn
          >
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col class="d-flex">
              <v-select
                label="Month"
                :items="months"
                item-text="text"
                item-value="value"
                v-model="form.month"
                class="mr-5"
              ></v-select>

              <v-select
                label="Year"
                :items="years"
                v-model="form.year"
              ></v-select>
            </v-col>
          </v-row>
          <div class="d-flex">
            <transactions-modal class="mr-2" />
            <chart-of-accounts-entries />
            <v-btn
              v-if="user.role == 'Admin'"
              color="pink"
              class="mr-2 white--text"
              rounded
              @click="print('journal_entries')"
              >Journal Entry</v-btn
            >
            <v-btn
              color="success"
              class="mr-2"
              rounded
              @click="print('trial_balance')"
              >Trial Balance</v-btn
            >

            <v-btn
              color="primary"
              class="mr-2"
              rounded
              @click="print('income_statement')"
              >Income Statement</v-btn
            >
            <v-btn
              color="yellow"
              class="mr-2"
              rounded
              @click="print('balance_sheet')"
              >Balance Sheet</v-btn
            >
          </div>

          <print-sales-summary-modal class="mt-5 mb-5" />
          <v-row>
            <v-col>
              <v-text-field
                label="Search"
                v-model="journal_search"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <div class="d-flex">
                <v-select
                  label="Month"
                  :items="months"
                  item-text="text"
                  item-value="value"
                  v-model="journalEntryMonth"
                  class="mr-5"
                ></v-select>

                <v-select
                  label="Year"
                  :items="years"
                  v-model="journalEntryYear"
                ></v-select>
                <v-btn
                  class="mt-2 ml-2"
                  @click="getJournalEntry()"
                  :loading="loading"
                  >Search</v-btn
                >
                <add-journal-entry-modal class="mt-2 ml-2" />
              </div>
            </v-col>
          </v-row>

          <v-data-table
            :items="journal_entries"
            :headers="journal_headers"
            :search="journal_search"
          >
            <!-- for debit and credit entries -->
            <template v-slot:item.credit="{ item }">
              <span v-if="!item.is_debit">{{
                item.amount.toLocaleString()
              }}</span>
            </template>
            <template v-slot:item.debit="{ item }">
              <span v-if="item.is_debit">{{
                item.amount.toLocaleString()
              }}</span>
            </template>

            <!-- colors of account title -->
            <template v-slot:item.account_title="{ item }">
              <v-chip
                color="success"
                v-if="item.chart_of_account.account_title == 'Cash'"
                >{{ item.chart_of_account.account_title }}</v-chip
              >

              <v-chip
                color="orange"
                v-else-if="
                  item.chart_of_account.account_title == 'Accounts Receivables'
                "
                >{{ item.chart_of_account.account_title }}</v-chip
              >
              <v-chip
                color="yellow"
                v-else-if="
                  item.chart_of_account.account_title == 'Service Revenue'
                "
                >{{ item.chart_of_account.account_title }}</v-chip
              >

              <v-chip
                color="primary"
                v-else-if="
                  item.chart_of_account.account_title == 'Sales/Item Sales'
                "
                >{{ item.chart_of_account.account_title }}</v-chip
              >

              <v-chip
                color="primary"
                v-else-if="item.chart_of_account.account_title == 'Gcash'"
                >{{ item.chart_of_account.account_title }}</v-chip
              >

              <v-chip color="grey" v-else>
                {{ item.chart_of_account.account_title }}
              </v-chip>
            </template>
            <!-- for invoice id -->
            <template v-slot:item.invoice_id="{ item }">
              <v-chip>{{ item.invoice_id }}</v-chip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                small
                icon
                color="red"
                @click="del(item)"
                :loading="loading"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </template>
          </v-data-table>

          <h2>
            Total Debit:
            <span class="success--text">{{
              total_debit_credit.debit.toLocaleString()
            }}</span>
            | Total Credit:
            <span class="primary--text">
              {{ total_debit_credit.credit.toLocaleString() }}</span
            >
          </h2>
        </v-card-text>
      </v-card>

      <!-- general ledger -->
      <v-divider class="mb-4 mt-4"></v-divider>
      <v-row>
        <v-col>
          <!-- cash flow component -->
          <cash-flow-statement class="mt-10 mb-10" />
          <!-- performance component -->
          <performance-table class="mt-10 mb-10" />
          <!-- <trial-balance /> -->
          <chart-of-accounts />
        </v-col>
        <!-- <v-col><income-statement-card /></v-col> -->
      </v-row>
      <v-divider class="mb-4 mt-4"></v-divider>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import ChartOfAccounts from "./ChartOfAccounts.vue";
import chartOfAccountsEntries from "../components/AccountingComponents/chartOfAccountsEntries.vue";
import TransactionsModal from "../components/AccountingComponents/transactionsModal.vue";
import CashFlowStatement from "../components/AccountingComponents/cashFlowStatement.vue";
import PrintSalesSummaryModal from "../components/Item/printSalesSummaryModal.vue";
import PerformanceTable from "../components/AccountingComponents/performanceTable.vue";
import AddJournalEntryModal from "../components/addJournalEntryModal.vue";
export default {
  components: {
    ChartOfAccounts,
    chartOfAccountsEntries,
    TransactionsModal,
    CashFlowStatement,
    PrintSalesSummaryModal,
    PerformanceTable,
    AddJournalEntryModal,
  },
  data() {
    return {
      journal_entries: [],
      journalEntryMonth: "",
      journalEntryYear: "",
      journal_search: "",
      form: {
        month: "",
        year: "",
      },
      months: [
        { text: "January", value: "01" },
        { text: "Febuary", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
      years: ["2024", "2025", "2026", "2027", "2028"],
      loading: false,
      journal_headers: [
        { text: "Action", value: "action" },
        { text: "Journal ID", value: "id" },

        { text: "Account Title", value: "chart_of_account.account_title" },
        { text: "Debit", value: "debit" },
        { text: "Credit", value: "credit" },
        { text: "Date", value: "created_at" },
        { text: "Remarks", value: "remarks" },
      ],
    };
  },
  methods: {
    getJournalEntry() {
      this.loading = true;
      axios
        .get(
          "/journalEntries/" +
            this.journalEntryMonth +
            "/" +
            this.journalEntryYear
        )
        .then((response) => {
          this.journal_entries = response.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.loading = false;
        });
    },
    print(form) {
      console.log(form);
      // check if empty
      if (this.form.month == "" || this.form.year == "")
        return alert("Please select date first");
      var url =
        this.default_server_url +
        "/print_report/" +
        form +
        "/" +
        this.form.month +
        "/" +
        this.form.year +
        "/" +
        this.user.branch_id;
      window.open(url);
    },
    del(item) {
      // return item;
      this.loading = true;
      let x = window.confirm("Are you sure you want to delete this item?");
      if (x) {
        this.delete_journal_entry(item).then(() => {
          alert("Successfully deleted an item");
        });
      }
      this.loading = false;
    },
    ...mapActions({
      delete_journal_entry: "journal_entry/delete_journal_entry",
    }),
    async refresh() {
      this.loading = true;
      await this.get_journal_entries();
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters({
      default_server_url: "auth/default_server_url",
      user: "auth/user",
    }),

    total_debit_credit() {
      return this.journal_entries.reduce(
        (totals, entry) => {
          if (entry.is_debit) {
            totals.debit += entry.amount;
          } else {
            totals.credit += entry.amount;
          }
          return totals;
        },
        { credit: 0, debit: 0 }
      );
    },
  },
  created() {
    let month = moment().format("MM");
    let year = moment().format("YYYY");

    this.journalEntryMonth = moment().format("MM");
    this.journalEntryYear = moment().format("YYYY");
    this.form.month = month;
    this.form.year = year;
    console.log(month, year);
    console.log(this.form);
  },
};
</script>

<style></style>
